<template>
	<v-row class="order-summary-sale-container" no-gutters>
		<v-col cols="12">
			<v-app-bar-nav-icon class="float-right" @click="HIDE_SIDE_NAV" v-if="$vuetify.breakpoint.xsOnly"></v-app-bar-nav-icon>

			<v-img :src="getEventImage.url" width="100%" transition="scale-transition"></v-img>
			<v-row no-gutters>
				<v-col cols="12" class="px-8 pt-10">
					<h3>{{ $t('ordersummarysale.summaryorder') }}</h3>
					<v-row v-for="ticketToSale in getTicketsToSale" :key="ticketToSale.ticketType.id">
						<v-col v-if="ticketToSale.ticketType.net == 0" cols="6">
							<h4 class="font-weight-medium pt-2">
								{{ ticketToSale.tickets.length }}x {{ ticketToSale.ticketType.name }}
							</h4>
							<p class="text-caption mb-0">
								{{ $t('selectortickettype.gratuita') }}
							</p>
						</v-col>
                        <v-col v-else cols="6">
							<h4 class="font-weight-medium pt-2">
								{{ ticketToSale.tickets.length }}x {{ ticketToSale.ticketType.name }}
							</h4>
							<p class="text-caption mb-0">
								{{ formatEuroNumber(ticketToSale.totalNet) }} +
								{{ formatEuroNumber(ticketToSale.totalVAT) }} {{ $t('ordersummarysale.taxticketday') }}
							</p>
						</v-col>
						<v-col cols="6" class="d-flex justify-end align-center">
							<p class="text-caption mb-0">{{ formatEuroNumber(ticketToSale.totalPrice) }}</p>
						</v-col>
					</v-row>
				</v-col>
				<div class="summary-divider">
					<v-divider></v-divider>
				</div>
				<v-col cols="12" class="px-8 mb-5">
					<v-row>
						<v-col cols="6">
							<h4 class="font-weight-medium">{{ $t('ordersummarysale.subtotal') }}</h4>
						</v-col>
						<v-col cols="6" class="d-flex justify-end align-center">
							<p class="text-caption mb-0">{{ formatEuroNumber(totalNet) }}</p>
						</v-col>
					</v-row>
					<v-row>
						<v-col cols="6">
							<h4 class="font-weight-medium pb-2">{{ $t('ordersummarysale.tax') }}</h4>
						</v-col>
						<v-col cols="6" class="d-flex justify-end align-center">
							<p class="text-caption mb-0">{{ formatEuroNumber(totalVat) }}</p>
						</v-col>
					</v-row>

					<v-divider class="pt-2"></v-divider>
					<v-row>
						<v-col cols="6">
							<h4>{{ $t('ordersummarysale.total') }}</h4>
						</v-col>
						<v-col cols="6" class="d-flex justify-end align-center">
							<h4>{{ formatEuroNumber(total) }}</h4>
						</v-col>
					</v-row>

					<v-divider class="pt-2 mt-4" v-if="total > 0"></v-divider>
					<v-row v-if="total > 0">
						<v-col cols="12">
							<p class="text-caption mb-0">
								{{ $t('ordersummarysale.warning') }}
							</p>
						</v-col>
					</v-row>
				</v-col>
			</v-row>
		</v-col>
	</v-row>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import numberUtils from '../../utils/numberUtils.js';

export default {
	methods: {
		...mapActions(['HIDE_SIDE_NAV', 'SHOW_SIDE_NAV']),
		formatEuroNumber(number = 0) {
			return numberUtils.formatEuroNumber(number);
		},
		javascriptDecimalSum(val1 = 0, val2 = 0) {
			return numberUtils.javascriptDecimalSum(val1, val2);
		}
	},
	computed: {
		...mapGetters(['getTicketsToSale', 'getEventImage']),
		totalNet() {
			return this.getTicketsToSale.reduce((acc, sale) => {
				return this.javascriptDecimalSum(sale.totalNet, acc);
			}, 0);
		},
		totalVat() {
			return this.getTicketsToSale.reduce((acc, sale) => {
				return this.javascriptDecimalSum(sale.totalVAT, acc);
			}, 0);
		},
		total() {
			return this.getTicketsToSale.reduce((acc, sale) => {
				return this.javascriptDecimalSum(sale.totalPrice, acc);
			}, 0);
		}
	}
};
</script>

<style>
.order-summary-sale-container {
	border-left: 1px solid #d2d7d9;
	height: 100%;
}

.summary-divider {
	padding-top: 1.5rem;
	padding-bottom: 1.5rem;
	width: 100%;
}
</style>
